module.exports = __webpack_public_path__ + "media/images/homepage/find_your_thu_character-74eae200e98a22e666e271cd48f8e4de.svg";